// @import dependencies
import React, { Component } from 'react'
// @end

// @import components
import { LoginModuleLayout } from './../index'
// @end

// @import types
import { IUserHttpResponse } from 'app_types/userTypes'
import AuthService from 'app_services/secure/auth/authService'
import ReactSelectService from 'app_services/components/reactSelectService'
// @end

// @ADD Component types
interface ILoginModuleProps {
  company?: any
  onSubmit: (credentials: any) => any
  onCompanySelected?: any
  onHandlePasswordRecover: (userData: IUserHttpResponse) => void
  hideIcons?: boolean;
  hidePersonBusiness?: boolean;
  hideForgotPassword?: boolean;
  hideReturnToCampus?: boolean;
  hideGoToRegister?: boolean;
  text?: string;
  history?: any;
  registerRedirect?: string
  onLoginSuccess?: () => void
}
interface ILoginModuleState {
  shouldValidate2FA: boolean
  error?: string
  loading?: boolean
}
class LoginModule extends Component<ILoginModuleProps, ILoginModuleState> {

  private reactSelectService: ReactSelectService

  constructor(props: any) {
    super(props)
    this.state = {
      shouldValidate2FA: false,
      loading: false
    }

    this.reactSelectService = new ReactSelectService()
  }

  componentDidMount() {}

  handleLogin = async (credentials: any) => {
    if (credentials.company) credentials.company = this.reactSelectService.formatReactSelectResponse(credentials.company)

    const authService = new AuthService()
    this.setState({ loading: true })
    const loginResult: any = await authService.login(credentials, this.props.history)

    if (loginResult?.status === 'error') {
      this.setState({ error: loginResult?.message })
    } else {
      if (loginResult?.check2fa) {
        this.setState({ shouldValidate2FA: true })
      } else {
        if (this.props.onLoginSuccess) {
          this.props.onLoginSuccess();
        }
      }
    }
    this.setState({ loading: false })
  }

  handleSubmit2FA = async (code: string) => {
    const authService = new AuthService()
    this.setState({ loading: true })
    const loginResult: any = await authService.validate2FA(code, this.props.history)
    if (loginResult?.status === 'error') {
      this.setState({ error: loginResult?.message })
    } else {
      if (this.props.onLoginSuccess) {
        this.props.onLoginSuccess();
      }
    }
    this.setState({ loading: false })
  }

  handlePasswordRecover = async (userData: IUserHttpResponse) => {
    const authService = new AuthService()
    this.setState({ loading: true })
    const loginResult: any = await authService.processLogin(userData, this.props.history)
    this.setState({ loading: false })
  }

  render() {
    return (
      <LoginModuleLayout
        company={this.props.company}
        // onSubmit={this.props.onSubmit}
        onSubmit={this.handleLogin}
        onCompanySelected={this.props.onCompanySelected}
        // onHandlePasswordRecover={this.props.onHandlePasswordRecover}
        onHandlePasswordRecover={this.handlePasswordRecover}
        hideIcons={this.props.hideIcons}
        hidePersonBusiness={this.props.hidePersonBusiness}
        hideForgotPassword={this.props.hideForgotPassword}
        hideGoToRegister={this.props.hideGoToRegister}
        hideReturnToCampus={this.props.hideReturnToCampus}
        text={this.props.text}
        history={this.props.history}
        shouldValidate2FA={this.state.shouldValidate2FA}
        handleSubmit2FA={this.handleSubmit2FA}
        loading={this.state.loading}
        registerRedirect={this.props.registerRedirect}
      />
    )
  }
}

export default LoginModule
